import React from 'react';
import styled from '@emotion/styled';
import { theme, icons } from '@ublend-npm/aulaui-next';

export const Container = styled.div`
  display: block;
`;

export const AssignmentBlock = styled.a<{
  isSelected: boolean;
  isDisabled: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  text-decoration: none;
  color: ${theme.color.black};
  background-color: ${theme.color.designSystem.grey20};
  border-radius: ${theme.borderRadius.medium};
  margin-top: ${theme.spacing.small};
  margin-bottom: ${theme.spacing.small};

  // Account for the border when adding padding
  margin-top: ${theme.spacing.xxSmall};
  padding: calc(${theme.spacing.medium} - 1px);
  padding-bottom: ${theme.spacing.xSmall};
  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.purple70}`
      : `1px solid ${theme.color.designSystem.grey20}`};
`;

export const Loader = styled.div`
  padding: 20px;
`;

export const AssignmentPropertiesContainer = styled((props) => (
  <div {...props} contentEditable={false} />
))`
  display: flex;
  align-items: center;
`;

export const AssignmentStatusLabel = styled.div`
  flex: 1
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.small};
  line-height: 16px;
  letter-spacing: 0.4px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing.xxSmall} ${theme.spacing.xSmall};
  background: ${theme.color.designSystem.background.light.success};

  border: 1px solid ${theme.color.blackAlpha(0.12)};
  box-sizing: border-box;
  border-radius: ${theme.spacing.xxSmall};

  max-height: 24px;
  margin-left: ${theme.spacing.xSmall};

  color: ${theme.color.designSystem.blackOpacity60};
`;

export const AssignmentUpcomingLabel = styled(AssignmentStatusLabel)`
  background: ${theme.color.designSystem.grey10};
`;

export const AssignmentNotGradedStatusLabel = styled(AssignmentStatusLabel)`
  background: ${theme.color.designSystem.grey10};
`;

export const AssignmentGradedStatusLabel = styled(AssignmentStatusLabel)`
  background: ${theme.color.designSystem.purple10};
`;

export const AssignmentPastDueStatusLabel = styled(AssignmentStatusLabel)`
  background: ${theme.color.designSystem.background.light.warning};
  border: none;
  color: ${theme.color.designSystem.blackOpacity87};
`;

export const AssignmentNotSubmittedStatusLabel = styled(AssignmentStatusLabel)`
  background: ${theme.color.designSystem.background.light.warning};
  border: 1px solid ${theme.color.designSystem.notificationLight};
`;

export const VisibilityOffIcon = styled(icons.VisibilityOff, {
  shouldForwardProp: (prop) => prop !== 'inSubtitle',
})<{
  inSubtitle: boolean;
}>`
  padding-left: ${({ inSubtitle }) => (!inSubtitle ? theme.spacing.xSmall : 0)};
  color: ${theme.color.designSystem.blackOpacity60};
  padding-right: ${({ inSubtitle }) => (inSubtitle ? theme.spacing.xSmall : 0)};
`;

export const ErrorIcon = styled(icons.ErrorIcon)`
  color: ${theme.color.designSystem.blackOpacity60};
  padding-right: ${theme.spacing.xSmall};
`;

export const DeleteIcon = styled(icons.Delete)`
  color: ${theme.color.designSystem.blackOpacity60};
  padding-right: ${theme.spacing.xSmall};
`;

export const AnonymousIcon = styled(
  React.forwardRef((props, ref) => (
    <icons.Anonymous ref={ref} viewBox="0 0 22 19" {...props} />
  ))
)`
  padding-left: ${theme.spacing.xSmall};
`;

export const GroupIcon = styled(
  React.forwardRef((props, ref) => <icons.Group ref={ref} {...props} />)
)`
  padding-left: ${theme.spacing.xSmall};
  color: ${theme.color.designSystem.blackOpacity60};
`;

export const AssignmentMainTitle = styled('span')`
  font-family: ${theme.font.family.workSans};
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  color: ${theme.color.designSystem.blackOpacity87};
`;

export const AssignmentSubtitle = styled('span')<{ disablePadding?: boolean }>`
  font-family: ${theme.font.family.workSans};
  font-style: normal;
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  color: ${theme.color.designSystem.blackOpacity60};

  padding-top: ${({ disablePadding }) =>
    !disablePadding ? theme.spacing.xSmall : 0};
`;

export const LoaderContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled((props) => (
  <div contentEditable={false} {...props} />
))`
  margin-left: -${theme.spacing.xxSmall};
  padding-top: ${theme.spacing.xxxSmall};
`;

export const AssignmentTitleContainer = styled((props) => (
  <div {...props} contentEditable={false} />
))`
  display: flex;
  flex-direction: column;
  padding-top: ${theme.spacing.xSmall};
  padding-bottom: ${theme.spacing.xxxSmall};
`;

export const InvalidAssignmentText = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: ${theme.spacing.xxSmall};
`;

export const InvalidAssignmentContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const Form = styled.form`
  display: none;
`;
